<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>网站设置</BreadcrumbItem>
          <BreadcrumbItem>热搜产品分类</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">热搜产品分类</div> 
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="classify=true" :disabled-hover="false">
          <span class="htb-add">+</span>
          <span>添加分类</span>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent;">
      <Table
        :border="false"
        row-key="id"
        :columns="columns"
        :data="type"
        :load-data="handleLoadData"
      >
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="nameEn">{{row.nameEn}}</template>
        <template slot-scope="{ row, index }" slot="categoryList">
          <template v-if="row.categoryList && false">
            <Poptip width="425" placement="right-start">
              <span
                v-for="(item, index) in row.categoryList"
                :key="'categoryList-' + Math.random()  + index"
              >
                <span v-if="Object.prototype.toString.call(item) === '[object Object]'">
                  {{item.Name}}
                  <span v-if="item.List && item.List.length">
                    {{' > ' + item.List[0].Name }}
                    <span
                      v-if="item.List[0].List && item.List[0].List.length"
                    >{{' >' + item.List[0].List[0].Name }}</span>
                  </span>

                  <span v-if="(index + 1) !== row.categoryList.length">;</span>
                </span>
                <span v-else>{{item}}</span>
              </span>
              <template slot="content">
                <div class="cate-pop-item">
                  <span
                    v-for="(item, index) in row.categoryList"
                    :key="'categoryList-pop-' + Math.random()  + index"
                  >
                    <span v-if="Object.prototype.toString.call(item) === '[object Object]'">
                      <span class="cate-brand">
                        {{item.Name}}
                        <Icon type="ios-close" class="cate-brand-close" />
                      </span>
                      <template v-if="item.List && item.List.length">
                        <span
                          class="cate-brand"
                          v-for="(item2, index2) in item.List"
                          :key="'categoryList-pop-1-' + index2"
                        >
                          {{ item2.Name}}
                          <Icon type="ios-close" class="cate-brand-close" />
                        </span>
                        <!-- <template v-if="item.List[0].List && item.List[0].List.length">
                          <span class="cate-brand"  v-for="(item3, index3) in item.List" :key="'categoryList-pop-3-' + index3">
                            {{ item.List[0].List[0].Name }}
                            <Icon type="ios-close" class="cate-brand-close" />
                          </span>
                        </template>-->
                      </template>
                    </span>
                    <span v-else>{{item}}</span>
                  </span>
                </div>
              </template>
            </Poptip>
          </template>
          <span style="color: #1890ff;cursor: pointer;" @click="showCategory(row)">查看</span>
        </template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <span style="color: #1890ff;cursor: pointer;" @click="editContactShow(row)">新增关联类别</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <!-- <span
              style="color: #1890ff;cursor: pointer;"
              @click="editSubShow(row)"
              v-if="row.type === 1 || row.type === 2"
            >添加子项</span> -->
            <!-- <span
              style="display: inline-block;padding: 0 5px;"
              v-if="row.type === 1 || row.type === 2"
            >|</span> -->
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </div>
        </template>
      </Table>
    </div>
    <!-- 修改展商置顶 -->

    <classifyAdd :show="classify" @finish="init()" @close="classify=false;" />
    <classifyEdit
      :show="editClassify"
      v-if="editClassify"
      @finish="init()"
      :editInfo="editClassifyInfo"
      @close="editClassify=false;editClassifyInfo=null;"
    />
    <classifyContactAdd
      :show="editclassifyContact"
      @finish="init()"
      :editInfo="editclassifyContactInfo"
      @close="editclassifyContact=false;editclassifyContactInfo=null;"
    />
    <classifySubAdd
      :show="editclassifySub"
      :info="editclassifySubInfo"
      @finish="init()"
      @close="editclassifySub=false;editclassifySubInfo=null;"
    />

    <iModal
      v-model="modal1"
      title="关联类别"
      @on-ok="modal1=false;categoryInfo=null;"
      @on-cancel="modal1=false;categoryInfo=null;"
    >
      <template v-if="categoryInfo && categoryInfo.length">
        <div class="ca-row">
          <div class="ca-row-left">一级类目：</div>
          <div class="ca-row-right">
            <p v-for="(item,index) in categoryInfo" :key="index">{{item.Name}}</p>
          </div>
        </div>
        <!-- <div v-if="categoryInfo[0].List && categoryInfo[0].List.length">
          <div class="ca-row">
            <div class="ca-row-left">二级类目：</div>
            <div class="ca-row-right">
              <span
                v-for="(item, index) in categoryInfo[0].List"
                :key="'categoryInfo.List-' + index"
              >{{index === 0 ? '' : ' / '}} {{item.Name}}</span>
            </div>
          </div>
        </div> -->
      </template>
    </iModal>
  </div>
</template>

<script>
import classifyAdd from "./components/classify-add.vue";
import classifyContactAdd from "./components/classify-contact-add";
import classifySubAdd from "./components/classify-sub-add";
import classifyEdit from "./components/classify-edit.vue";
import { mapActions } from "vuex";

export default {
  name: "host-set-host-pro",
  data() {
    return {
      categoryInfo: null,
      modal1: false,
      columns: [
        {
          title: "分类类别",
          key: "name",
          tree: true,
          width: "300px"
        },
        {
          title: "英文分类类别",
          key: "nameEn",
        },
        {
          title: "关联类别",
          slot: "categoryList",
          key: "categoryList",
          className: "cate-item",
          width: "400px"
        },
        {
          title: "排序",
          key: "showIndex",
          width: "100px"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      classify: false,
      editClassify: false,
      editClassifyInfo: null,
      editclassifyContact: false,
      editclassifyContactInfo: null,
      editclassifySub: false,
      editclassifySubInfo: null,
      type: [],
      parent1: null
    };
  },
  components: {
    classifyAdd,
    classifyEdit,
    classifyContactAdd,
    classifySubAdd
  },
  computed: {
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Categories",
                  Value: "%%"
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "ExHall",
                  Value: "%%"
                }
              },
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.search}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getWebKindGetByAgent: "webKindModule/getWebKindGetByAgent",
      putWebKind: "webKindModule/putWebKind",
      delWebKind: "webKindModule/delWebKind",
      addWebKind: "webKindModule/addWebKind", 
    }),
    async init() {
      let categoryData = await this.getWebKindGetByAgent(
        this.exhibitionInfo.agentId
      ); 
      if (categoryData && categoryData.length) {
        categoryData.map(c => {
          c.type = 1;
          c.num = 0;
          if (c.num) {
            c.children = [];
            c._loading = false;
          }
          if (c.categoryList) {
            c.categoryList = JSON.parse(c.categoryList);
          } else {
            c.categoryList = [];
          }
        });
        this.type = categoryData;
      } else {
        this.type = [];
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    setClassify(item) {
      // 设置置顶
      this.classifyInfo = item;
      this.classify = true;
    },
    setClassifyEdit(item) {
      // 设置品牌
      this.editClassifyInfo = item;
      this.editClassify = true;
    },
    searchPro() {
      this.pageIndex = 1;
      this.init();
    },
    async delItem(item) {
      let result = await this.delWebKind(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    handleLoadData(item, callback) {
      const list = JSON.parse(JSON.stringify(item.list));
      list.map(c => {
        c.type = item.type + 1;
        c.num = c.list.length;
        if (c.num) {
          c.children = [];
          c._loading = false;
        }
        if (c.categoryList) {
          c.categoryList = JSON.parse(c.categoryList);
        } else {
          c.categoryList = [];
        }
      });
      callback(list);
    },
    addContactSub() {},
    addSub() {},
    editShow(e) {
      this.editClassify = true;
      this.editClassifyInfo = e;
    },
    editContactShow(e) {
      this.editclassifyContact = true;
      this.editclassifyContactInfo = e;
      console.log(this.editclassifyContactInfo)
    },
    editSubShow(e) {
      this.editclassifySub = true;
      this.editclassifySubInfo = e;
    },
    close() {
      this.classify = false;
      this.editClassify = false;
      this.editClassifyInfo = null;
      this.editclassifyContact = false;
      this.editclassifyContactInfo = null;
    },
    showCategory(row) {
      this.categoryInfo = row.categoryList;
      console.log(" this.categoryInfo: ", this.categoryInfo);
      this.modal1 = true;
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}
.layout-content {
  table {
  }
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;
  &:hover {
    color: #1890ff;
  }
}
.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;
  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;
    :hover {
      color: #333;
    }
    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>

